import { render, staticRenderFns } from "./candidate.vue?vue&type=template&id=fbea8fe2&"
import script from "./candidate.vue?vue&type=script&lang=js&"
export * from "./candidate.vue?vue&type=script&lang=js&"
import style0 from "./candidate.vue?vue&type=style&index=0&id=fbea8fe2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports